import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import store from './app/store';
import { injectStore } from './shared/api/client';
import { injectAuthStore } from './utils/auth';
import { restoreSession } from './features/auth/authSlice';
import queryClient from './shared/api/queryClient';
import './index.css';
import App from './App';

// Inject Redux store into the API client to avoid circular imports
injectStore(store);
injectAuthStore(store);

// Start exactly one cookie-backed restore before protected routes can mount.
// ProtectedRoute keeps the application on its loading state until this thunk
// resolves, so authenticated React Query hooks cannot fire without a JWT.
store.dispatch(restoreSession());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
        {process.env.NODE_ENV === 'development' && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);
